"use client";

import { useRouter } from "next/navigation";
import { NotFoundPage } from "@/components/ui/error-layout";

export default function NotFound() {
  const router = useRouter();

  return (
    <NotFoundPage
      variant="missing"
      onGoHome={() => router.push("/home")}
      onSwitchAccount={() => router.push("/logout")}
    />
  );
}
